// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","1761":"d0deef33"}[chunkId] || chunkId) + "." + {"501":"383a1700d6d6307d","1761":"6f799cb9bfd499e4","2931":"2a7ba3d0a78d15c9","6457":"2836474f9bc0af5c","7267":"b65a38cc74f2e489"}[chunkId] + ".js";
};